import { Component, HostBinding, Input } from '@angular/core';
import IAllowedUse = ZoneIQCalibration.IAllowedUse;
import { TableFieldOption } from 'src/shared/enums';
import ICalibrationUsesVal = ZoneIQCalibration.ICalibrationUsesVal;
import { IBaseTableCell } from 'src/app/interfaces/tables/cells/base-table-cell-interface';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'ziq-uses-cell',
    templateUrl: './ziq-uses-cell.component.html',
    styleUrls: ['./ziq-uses-cell.component.scss']

})
export class ZIQUsesCellComponent {
    @Input()
    use?: IBaseTableCell<ICalibrationUsesVal>;

    @Input()
    visibilityOptions: any;

    @Input()
    useAllowances: IAllowedUse[];

    @Input()
    currentTab: string;

    @Input()
    attributePopupTitleDetails?: string;

    @Input()
    hideAttributeButtons: boolean = false;

    @Input()
    readOnly: boolean = false;

    @HostBinding('class')
    readonly hostClass = 'ziq-uses-cell';

    tableFieldOption = TableFieldOption;

    get fieldsSettings() {
        return _.get(this.use, 'value.fieldsSettings');
    }
}
